module.exports = "/img/_/_/_/assets/images//main_menu_item.png?d3cd1edb2be5be3bec2726729320ed0d";